import { fetchFillAdvisorData } from 'api/fillAdvisor';
import {
  GET_FILL_ADVISOR_DATA,
} from 'actions/actionTypes';
import {
  getFillAdvisorDataSuccess,
  getFillAdvisorDataFailure,
} from 'actions';
import { apiPromise } from '../apiPromise';

export const fillAdvisor = store => next => (action) => {
  switch (action.type) {
    case GET_FILL_ADVISOR_DATA.REQUEST: {
      next(action);
      return apiPromise(
        store,
        action,
        fetchFillAdvisorData,
        [],
        getFillAdvisorDataSuccess,
        getFillAdvisorDataFailure
      );
    }
    default:
      next(action);
      return Promise.resolve();
  }
};

export default fillAdvisor;
